import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode'; // Correct import for jwt-decode
import { FaRegUserCircle } from "react-icons/fa"; // Import user icon

const LoginText = ({ toggleModal }) => {
  const [userName, setUserName] = useState('Guest');

  useEffect(() => {
    // Get the token from localStorage
    const token = localStorage.getItem('google_token');

    if (token) {
      try {
        // Decode the token
        const decodedToken = jwtDecode(token);
        console.log('Decoded Token:', decodedToken);

        // Parse the `sub` field as JSON
        const subData = JSON.parse(decodedToken.sub);
        console.log('Parsed subData:', subData);

        // Extract the username and email
        const name = subData.username || '';
        const email = subData.email_id || '';

        // Set the name as the first part of the full name or fallback to the email username
        if (name.trim()) {
          setUserName(name.split(' ')[0]); // Set the first part of the name
        } else {
          setUserName(email.split('@')[0]); // Fallback to email username
        }

      } catch (error) {
        console.error('Error decoding or parsing token:', error);
      }
    }
  }, []);

  return (
    <button
      onClick={toggleModal} // Call the modal toggle function on click
      className="text-gray-800 hover:text-gray-300 flex items-center space-x-2 text-sm md:text-base"
    >
      {/* Replace profile image with user icon */}
      <FaRegUserCircle className="w-6 h-6 text-gray-800" />
      <span>Hi, {userName}</span>
    </button>
  );
};

export default LoginText;
